import axios from "axios";

function Axios(method, url, data, config) {
  return axios({
    method: method,
    url: url,
    data: data,
    config: config,
  })
    .then((res) => {
      if (
        method.toUpperCase() === "DELETE" ||
        method.toUpperCase() === "LOCK" ||
        method.toUpperCase() === "PATCH"
      ) {
        if (res.status === 200 || res.status === 204) {
          return true;
        } else {
          return false;
        }
      } else {
        if (res.data !== undefined && res.data !== null && res.data !== "") {
          return res.data;
        } else if (res.status >= 200 && res.status < 300) {
          return true;
        } else {
          return false;
        }
      }
    })
    .catch((error) => {
      return null;
    });
}

export { Axios };
